<hpf-point-of-interest-form
        [pointOfInterest]="pointOfInterest"
        [loading]="pointOfInterest.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-point-of-interest-form>
<div class="container">
</div>
